module.exports = "<img style=\"margin: auto;\" ng-src=\"{{ vm.file.blobUrl }}\" />\n";